<template>
  <BaseModal :title="stageTitle" @close="closeModal">
    <template #modalContent>
      <div
        v-if="streamStage === 'youtube' || streamStage === 'linkedin'"
        class="ccf"
      >
        <button type="button" class="ccf-stage-back" @click="cancelStage">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Back
        </button>
        <div class="ccf-stage-head">
          <span v-if="streamStage === 'youtube'" class="ccf-stage-icon yt">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.546 15.568V8.432L15.818 12l-6.272 3.568z"
              />
            </svg>
          </span>
          <span v-else class="ccf-stage-icon li"
            ><svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              /></svg
          ></span>
          <div>
            <p class="ccf-stage-eyebrow">Live streaming</p>
            <h2 class="ccf-stage-title">{{ stageCopy.title }}</h2>
          </div>
        </div>
        <p class="ccf-stage-sub">{{ stageCopy.sub }}</p>

        <div class="ccf-field">
          <label class="ccf-label"
            >RTMP URL <span class="ccf-req">*</span></label
          >
          <input
            v-model="streamYoutubeUrlDraft"
            type="text"
            class="ccf-input"
            :placeholder="stageCopy.placeholder"
            @input="streamErrors.url = ''"
          />
          <p v-if="streamErrors.url" class="ccf-err">{{ streamErrors.url }}</p>
        </div>

        <div class="ccf-field">
          <label class="ccf-label"
            >Stream key <span class="ccf-req">*</span></label
          >
          <input
            v-model="streamYoutubeKeyDraft"
            :type="showStreamKey ? 'text' : 'password'"
            class="ccf-input"
            placeholder="Paste your stream key"
            @input="streamErrors.key = ''"
          />
          <div class="ccf-stage-key-row">
            <button
              type="button"
              class="ccf-stage-key-toggle"
              @click="showStreamKey = !showStreamKey"
            >
              {{ showStreamKey ? 'Hide key' : 'Show key' }}
            </button>
            <p v-if="streamErrors.key" class="ccf-err">
              {{ streamErrors.key }}
            </p>
          </div>
        </div>

        <div class="ccf-actions">
          <button
            v-if="stageConnected"
            type="button"
            class="ccf-btn ghost"
            @click="removeStage"
          >
            Remove destination
          </button>
          <button type="button" class="ccf-btn ghost" @click="cancelStage">
            Cancel
          </button>
          <button type="button" class="ccf-btn primary" @click="saveStage">
            Save destination
          </button>
        </div>
      </div>

      <div v-else class="ccf">
        <div class="ccf-field">
          <label class="ccf-label">Name <span class="ccf-req">*</span></label>
          <input
            v-model="stepOneProps.event_name"
            type="text"
            class="ccf-input"
            placeholder="e.g. Q3 product review"
            maxlength="80"
            @input="errors.event_name = ''"
          />
          <p v-if="errors.event_name" class="ccf-err">
            {{ errors.event_name }}
          </p>
        </div>

        <div class="ccf-field">
          <label class="ccf-label"
            >Description <span class="ccf-req">*</span></label
          >
          <textarea
            v-model="stepOneProps.description"
            class="ccf-input ccf-textarea"
            rows="2"
            placeholder="Short description shown to attendees"
            maxlength="400"
            @input="errors.description = ''"
          ></textarea>
          <p v-if="errors.description" class="ccf-err">
            {{ errors.description }}
          </p>
        </div>

        <div v-if="!isEdit" class="ccf-section">
          <button
            type="button"
            class="ccf-section-toggle ccf-sched-row"
            @click="isScheduled = !isScheduled"
          >
            Schedule for later
            <span class="ccf-stream-toggle" :class="{ on: isScheduled }">
              <span class="ccf-stream-toggle-thumb"></span>
            </span>
          </button>
          <div v-show="isScheduled" class="ccf-section-body">
            <div class="ccf-row">
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Date</label>
                <input
                  v-model="stepOneProps.startD"
                  type="date"
                  class="ccf-input"
                  :min="minDate"
                  @change="onScheduleChange"
                />
              </div>
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Time</label>
                <input
                  v-model="startTimeHm"
                  type="time"
                  class="ccf-input"
                  @change="onScheduleChange"
                />
              </div>
            </div>
            <p v-if="errors.schedule" class="ccf-err">{{ errors.schedule }}</p>
          </div>
        </div>
        <template v-else>
          <div class="ccf-row">
            <div class="ccf-field ccf-half">
              <label class="ccf-label">Date</label>
              <input
                v-model="stepOneProps.startD"
                type="date"
                class="ccf-input"
                :min="minDate"
                @change="onScheduleChange"
              />
            </div>
            <div class="ccf-field ccf-half">
              <label class="ccf-label">Time</label>
              <input
                v-model="startTimeHm"
                type="time"
                class="ccf-input"
                @change="onScheduleChange"
              />
            </div>
          </div>
          <p v-if="errors.schedule" class="ccf-err">{{ errors.schedule }}</p>
        </template>

        <!-- TEMP: "Who can join" hidden. Default stays 'public' (set
             in mounted() via applyAuthChoice). Re-enable by removing
             the v-if guard. -->
        <div v-if="false" class="ccf-field">
          <label class="ccf-label">Who can join</label>
          <div class="ccf-pills">
            <button
              v-for="opt in authOptions"
              :key="opt.value"
              type="button"
              class="ccf-pill"
              :class="{ active: authChoice === opt.value }"
              @click="setAuthChoice(opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
          <p v-if="authChoice === 'password'" class="ccf-sub-field">
            <input
              v-model="stepOneProps.moderator_password"
              type="text"
              class="ccf-input"
              placeholder="Set a password"
            />
          </p>
        </div>

        <div class="ccf-section">
          <button
            type="button"
            class="ccf-section-toggle"
            @click="showBranding = !showBranding"
          >
            <span class="ccf-section-chev" :class="{ open: showBranding }"
              >▸</span
            >
            Branding
            <span class="ccf-section-meta">optional</span>
          </button>
          <div v-show="showBranding" class="ccf-section-body">
            <div class="ccf-row ccf-branding-row">
              <div class="ccf-field">
                <label class="ccf-label">Logo</label>
                <div class="ccf-upload-tile logo" @click="triggerLogoUpload">
                  <img
                    v-if="logoPreview"
                    :src="logoPreview"
                    class="ccf-upload-img"
                  />
                  <span v-else class="ccf-upload-hint">+ Click to upload</span>
                  <input
                    ref="logoInput"
                    type="file"
                    accept="image/*"
                    style="display: none"
                    @change="onLogoChange"
                  />
                </div>
              </div>
              <div class="ccf-field ccf-grow">
                <label class="ccf-label">Cover image</label>
                <div
                  class="ccf-upload-tile cover"
                  :class="{ filled: !!coverPreview }"
                  @click="triggerCoverUpload"
                >
                  <img
                    v-if="coverPreview"
                    :src="coverPreview"
                    class="ccf-upload-img cover"
                  />
                  <span v-else class="ccf-upload-hint"
                    >+ Upload cover image</span
                  >
                  <button
                    v-if="coverPreview"
                    type="button"
                    class="ccf-upload-remove"
                    @click.stop="removeCover"
                  >
                    ×
                  </button>
                  <input
                    ref="coverInput"
                    type="file"
                    accept="image/*"
                    style="display: none"
                    @change="onCoverChange"
                  />
                </div>
              </div>
            </div>

            <div class="ccf-row">
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Primary color</label>
                <div class="ccf-color-row">
                  <input
                    v-model="stepTwoProps.primary_color"
                    type="color"
                    class="ccf-color"
                  />
                  <input
                    v-model="stepTwoProps.primary_color"
                    type="text"
                    class="ccf-input ccf-color-text"
                    maxlength="7"
                  />
                </div>
              </div>
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Welcome text</label>
                <input
                  v-model="stepTwoProps.welcome_text"
                  type="text"
                  class="ccf-input"
                  placeholder="Shown when attendees join"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isEdit" class="ccf-section">
          <button
            type="button"
            class="ccf-section-toggle"
            @click="showLiveStreaming = !showLiveStreaming"
          >
            <span class="ccf-section-chev" :class="{ open: showLiveStreaming }"
              >▸</span
            >
            Live streaming
            <span class="ccf-section-meta">
              <span v-if="streamActiveCount" class="ccf-stream-count">
                {{ streamActiveCount }} active
              </span>
              <span v-else>optional</span>
            </span>
          </button>
          <div v-show="showLiveStreaming" class="ccf-section-body">
            <div class="ccf-stream-grid">
              <!-- Decast Player toggle tile -->
              <button
                type="button"
                class="ccf-stream-card"
                :class="{ on: vwStream }"
                @click="vwStream = !vwStream"
              >
                <span class="ccf-stream-card-side decast"></span>
                <span class="ccf-stream-card-body">
                  <span class="ccf-stream-card-row">
                    <span class="ccf-stream-card-name">Decast player</span>
                    <span class="ccf-stream-toggle" :class="{ on: vwStream }">
                      <span class="ccf-stream-toggle-thumb"></span>
                    </span>
                  </span>
                  <span class="ccf-stream-card-state">
                    <span v-if="vwStream" class="ccf-stream-pulse"></span>
                    {{ vwStream ? 'Enabled' : 'Get a public stream page URL' }}
                  </span>
                </span>
              </button>

              <!-- YouTube tile -->
              <button
                type="button"
                class="ccf-stream-card youtube"
                :class="{ on: streamYoutubeConnected }"
                @click="openPlatform('youtube')"
              >
                <span class="ccf-stream-card-side yt"></span>
                <span class="ccf-stream-card-body">
                  <span class="ccf-stream-card-row">
                    <span class="ccf-stream-card-icon yt">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.546 15.568V8.432L15.818 12l-6.272 3.568z"
                        />
                      </svg>
                    </span>
                    <span class="ccf-stream-card-name">YouTube</span>
                    <span class="ccf-stream-card-chev">›</span>
                  </span>
                  <span class="ccf-stream-card-state">
                    <span
                      v-if="streamYoutubeConnected"
                      class="ccf-stream-pulse green"
                    ></span>
                    {{
                      streamYoutubeConnected
                        ? 'Connected'
                        : 'Tap to add RTMP + stream key'
                    }}
                  </span>
                </span>
              </button>

              <!-- LinkedIn tile -->
              <button
                type="button"
                class="ccf-stream-card linkedin"
                :class="{ on: streamLinkedinConnected }"
                @click="openPlatform('linkedin')"
              >
                <span class="ccf-stream-card-side li"></span>
                <span class="ccf-stream-card-body">
                  <span class="ccf-stream-card-row">
                    <span class="ccf-stream-card-icon li"
                      ><svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path
                          d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                        /></svg
                    ></span>
                    <span class="ccf-stream-card-name">LinkedIn</span>
                    <span class="ccf-stream-card-chev">›</span>
                  </span>
                  <span class="ccf-stream-card-state">
                    <span
                      v-if="streamLinkedinConnected"
                      class="ccf-stream-pulse green"
                    ></span>
                    {{
                      streamLinkedinConnected
                        ? 'Connected'
                        : 'Tap to add RTMPS + stream key'
                    }}
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>

        <div class="ccf-section">
          <button
            type="button"
            class="ccf-section-toggle"
            @click="showAdvanced = !showAdvanced"
          >
            <span class="ccf-section-chev" :class="{ open: showAdvanced }"
              >▸</span
            >
            Advanced settings
            <span class="ccf-section-meta">optional</span>
          </button>
          <div v-show="showAdvanced" class="ccf-section-body">
            <div class="ccf-row">
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Max participants</label>
                <input
                  v-model.number="stepOneProps.max_participant"
                  type="number"
                  min="1"
                  max="1000"
                  class="ccf-input"
                />
              </div>
              <div class="ccf-field ccf-half">
                <label class="ccf-label">Duration (minutes)</label>
                <input
                  v-model="stepTwoProps.duration"
                  type="number"
                  min="5"
                  max="600"
                  class="ccf-input"
                />
              </div>
            </div>

            <p
              v-if="storageNote"
              id="ccf-record-note"
              class="ccf-note"
              :class="storageNote.tone"
            >
              {{ storageNote.text }}
              <router-link to="/dashboard/account">See plans</router-link>
            </p>

            <div class="ccf-toggles">
              <label
                class="ccf-toggle"
                :class="{ 'ccf-toggle-disabled': recordingBlocked }"
              >
                <input
                  v-model="stepFourProps.record"
                  type="checkbox"
                  :disabled="recordingBlocked"
                  aria-describedby="ccf-record-note"
                />
                <span>Record this cast</span>
              </label>
              <label
                class="ccf-toggle"
                :class="{ 'ccf-toggle-disabled': !stepFourProps.record }"
              >
                <input
                  v-model="stepFourProps.auto_start_recording"
                  type="checkbox"
                  :disabled="!stepFourProps.record"
                />
                <span>Auto-start recording</span>
              </label>
              <label class="ccf-toggle">
                <input v-model="stepFourProps.mute_on_start" type="checkbox" />
                <span>Mute attendees on join</span>
              </label>
              <label class="ccf-toggle">
                <input
                  v-model="stepFourProps.end_when_no_moderator"
                  type="checkbox"
                />
                <span>End when host leaves</span>
              </label>
              <!-- TEMP: hidden until the toggles are wired end-to-end.
                   Re-enable by removing the v-if guards. -->
              <label v-if="false" class="ccf-toggle">
                <input
                  v-model="stepFourProps.webcam_only_for_moderator"
                  type="checkbox"
                />
                <span>Webcam: host only</span>
              </label>
              <label v-if="false" class="ccf-toggle">
                <input v-model="stepOneProps.hide_users" type="checkbox" />
                <span>Hide attendee list</span>
              </label>
            </div>
          </div>
        </div>

        <div class="ccf-actions">
          <button type="button" class="ccf-btn ghost" @click="closeModal">
            Cancel
          </button>
          <button
            type="button"
            class="ccf-btn primary"
            :disabled="submitting"
            @click="submit"
          >
            {{ submitLabel }}
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import {
  accountSummary,
  currentAccount,
  subscribeAccount,
} from '@/http/requests/account';
import moment from 'moment-timezone';
import BaseModal from '@/components/common/BaseModal.vue';

// TEMP: lead-time check is disabled. Re-enable by flipping
// ENFORCE_MIN_LEAD to true (or just remove the flag).
const MIN_LEAD_HOURS = 1;
const ENFORCE_MIN_LEAD = false;

// Validates an RTMP destination - same rules used in the inline
// stream stage of CreateCastForm and in StreamPlatformForm so the
// edit and create flows agree.
const RTMP_PROTOCOL_RE = /^rtmps?:\/\//i;
const RTMP_HOST_HINTS = {
  youtube: /youtube\.com|googlevideo|youtu\.be/i,
  facebook: /facebook\.com|fbcdn\.net|facebook/i,
  twitch: /twitch\.tv/i,
  linkedin: /linkedin\.com|bitcod\.in/i,
};
const RTMP_KEY_RE = /^[A-Za-z0-9._\-=:+/]+$/;

export function validateRtmpDestination(url, key, platformKey) {
  const errors = { url: '', key: '' };
  if (!url) {
    errors.url = 'RTMP URL is required.';
  } else if (!RTMP_PROTOCOL_RE.test(url)) {
    errors.url = 'URL must start with rtmp:// or rtmps://.';
  } else {
    try {
      const u = new URL(url);
      if (!u.host) errors.url = 'URL is missing a host.';
      else if (
        platformKey &&
        RTMP_HOST_HINTS[platformKey] &&
        !RTMP_HOST_HINTS[platformKey].test(u.host)
      ) {
        errors.url = `This doesn't look like a ${platformKey} RTMP endpoint.`;
      }
    } catch (e) {
      errors.url = 'URL is malformed.';
    }
  }

  if (!key) {
    errors.key = 'Stream key is required.';
  } else if (key.length < 8) {
    errors.key = 'Stream key looks too short.';
  } else if (key.length > 200) {
    errors.key = 'Stream key looks too long.';
  } else if (!RTMP_KEY_RE.test(key)) {
    errors.key = 'Stream key has unsupported characters.';
  }

  return errors;
}

function roundUpToQuarter(m) {
  const mins = m.minute();
  const add = (15 - (mins % 15)) % 15;
  return m.clone().add(add, 'minutes').seconds(0).milliseconds(0);
}

export default {
  name: 'CreateCastForm',
  components: { BaseModal },
  props: {
    closeModal: { type: Function, default: null },
    createCast: { type: Function, default: null },
    handleEditCast: { type: Function, default: null },
    stepOneProps: { type: Object, required: true },
    stepTwoProps: { type: Object, required: true },
    stepThreeProps: { type: Object, default: null },
    stepFourProps: { type: Object, required: true },
    setActiveModal: { type: Function, default: null },
    mode: { type: String, default: 'create' }, // 'create' | 'edit'
  },
  data() {
    return {
      account: currentAccount(),
      submitting: false,
      showBranding: false,
      showAdvanced: false,
      isScheduled: false,
      showLiveStreaming: false,
      // Live streaming state. Lives locally until submit, then we
      // compose `is_streaming`, `vw_stream`, `vw_stream_url` into
      // stepThreeProps so the existing create payload picks it up.
      streamStage: 'main', // 'main' | 'youtube' | 'linkedin'
      vwStream: false,
      streamYoutubeUrl: '',
      streamYoutubeKey: '',
      streamYoutubeConnected: false,
      streamLinkedinUrl: '',
      streamLinkedinKey: '',
      streamLinkedinConnected: false,
      // Draft fields edited in the YouTube stage. Committed to the
      // real fields on Save.
      streamYoutubeUrlDraft: '',
      streamYoutubeKeyDraft: '',
      showStreamKey: false,
      streamErrors: { url: '', key: '' },
      logoPreview: '',
      coverPreview: '',
      // Local UI state for auth choice. Maps onto the existing
      // meeting_type/password_auth/send_otp/public_otp/vc_gated bag.
      authChoice: 'public',
      // VC option is hidden from the menu but kept in code.
      showVcOption: false,
      authOptions: [
        { value: 'public', label: 'Public link' },
        { value: 'password', label: 'Password' },
        { value: 'otp', label: 'OTP by email' },
      ],
      errors: {
        event_name: '',
        description: '',
        schedule: '',
      },
    };
  },
  watch: {
    isScheduled(v) {
      this.stepOneProps.is_instant = !v;
    },
    'stepFourProps.record'(v) {
      if (!v) {
        this.stepFourProps.auto_start_recording = false;
      }
    },
  },
  computed: {
    recordingBlocked() {
      return !!(this.account && this.account.recordingBlocked);
    },
    /** What to say about storage beside the recording toggle, if anything. */
    storageNote() {
      const acc = this.account;
      if (!acc || !acc.storage || !acc.storage.allowed) return null;
      if (acc.recordingBlocked) {
        return {
          tone: 'bad',
          text: `Storage is full (${acc.storage.usedLabel} of ${acc.storage.allowedLabel}), so this cast cannot be recorded. It will still run live.`,
        };
      }
      if (acc.storage.tone === 'over') {
        return {
          tone: 'warn',
          text: acc.grace
            ? `Storage is full (${acc.storage.usedLabel} of ${
                acc.storage.allowedLabel
              }). Recording stops on ${acc.grace.deadline.slice(
                0,
                10
              )} unless you free space or upgrade.`
            : `Storage is full: ${acc.storage.usedLabel} of ${acc.storage.allowedLabel}.`,
        };
      }
      if (acc.storage.tone === 'warn') {
        return {
          tone: 'warn',
          text: `This will use part of the ${acc.storage.allowedLabel} on your plan; ${acc.storage.usedLabel} is already stored.`,
        };
      }
      return null;
    },
    isEdit() {
      return this.mode === 'edit';
    },
    modalTitle() {
      return this.isEdit ? 'Edit cast' : 'Create cast';
    },
    submitLabel() {
      if (this.submitting) return this.isEdit ? 'Saving…' : 'Creating…';
      return this.isEdit ? 'Save changes' : 'Create cast';
    },
    stageTitle() {
      if (this.streamStage === 'youtube') return 'YouTube destination';
      if (this.streamStage === 'linkedin') return 'LinkedIn destination';
      return this.modalTitle;
    },
    stageCopy() {
      if (this.streamStage === 'linkedin') {
        return {
          title: 'LinkedIn destination',
          sub: 'Paste the stream URL and key from your LinkedIn Live custom-stream setup.',
          placeholder: 'rtmps://….live-input-li.bitcod.in/live',
        };
      }
      return {
        title: 'YouTube destination',
        sub: 'Paste the RTMP URL and stream key from your YouTube Studio go-live dashboard.',
        placeholder: 'rtmp://a.rtmp.youtube.com/live2',
      };
    },
    stageConnected() {
      return this.streamStage === 'linkedin'
        ? this.streamLinkedinConnected
        : this.streamYoutubeConnected;
    },
    streamActiveCount() {
      return (
        (this.vwStream ? 1 : 0) +
        (this.streamYoutubeConnected ? 1 : 0) +
        (this.streamLinkedinConnected ? 1 : 0)
      );
    },
    minDate() {
      if (!ENFORCE_MIN_LEAD) return moment().format('YYYY-MM-DD');
      return moment().add(MIN_LEAD_HOURS, 'hours').format('YYYY-MM-DD');
    },
    startTimeHm: {
      get() {
        const raw = this.stepOneProps.startTime || '00:00:00';
        return raw.length >= 5 ? raw.slice(0, 5) : raw;
      },
      set(v) {
        // input type=time gives 'HH:mm'. Backend wants HH:mm:ss.
        this.stepOneProps.startTime = v && v.length === 5 ? `${v}:00` : v;
      },
    },
  },
  mounted() {
    this.unsubscribeAccount = subscribeAccount((acc) => {
      this.account = acc;
      if (acc && acc.recordingBlocked) this.stepFourProps.record = false;
    });
    accountSummary().catch(() => {});
    // In edit mode keep the existing schedule the parent hydrated.
    // In create mode default to now + 2 hours, rounded to next 15 min.
    if (!this.isEdit) {
      const defaultStart = roundUpToQuarter(moment().add(2, 'hours'));
      this.stepOneProps.startD = defaultStart.format('YYYY-MM-DD');
      this.startTimeHm = defaultStart.format('HH:mm');
      this.stepOneProps.start_now = false;
      this.stepOneProps.is_instant = true;
    }

    // Default auth choice mirrors current flags.
    if (this.stepOneProps.vc_gated) this.authChoice = 'vc';
    else if (this.stepOneProps.password_auth) this.authChoice = 'password';
    else if (this.stepOneProps.send_otp) this.authChoice = 'otp';
    else this.authChoice = 'public';
    this.applyAuthChoice(this.authChoice);

    // Hydrate previews if branding was set in an earlier mount.
    if (this.stepTwoProps.logo && typeof this.stepTwoProps.logo !== 'string') {
      this.logoPreview = URL.createObjectURL(this.stepTwoProps.logo);
    }
    if (
      this.stepTwoProps.cover_image &&
      typeof this.stepTwoProps.cover_image !== 'string'
    ) {
      this.coverPreview = URL.createObjectURL(this.stepTwoProps.cover_image);
    }
  },
  beforeDestroy() {
    if (this.unsubscribeAccount) this.unsubscribeAccount();
  },
  methods: {
    setAuthChoice(value) {
      this.authChoice = value;
      this.applyAuthChoice(value);
    },
    applyAuthChoice(value) {
      // Reset all auth flags first.
      this.stepOneProps.password_auth = false;
      this.stepOneProps.send_otp = false;
      this.stepOneProps.public_otp = false;
      this.stepOneProps.vc_gated = false;
      if (value === 'public') {
        this.stepOneProps.auth_type = 'public';
        this.stepOneProps.meeting_type = 'public';
      } else if (value === 'password') {
        this.stepOneProps.auth_type = 'private';
        this.stepOneProps.meeting_type = 'private';
        this.stepOneProps.password_auth = true;
      } else if (value === 'otp') {
        this.stepOneProps.auth_type = 'private';
        this.stepOneProps.meeting_type = 'private';
        this.stepOneProps.send_otp = true;
      } else if (value === 'vc') {
        this.stepOneProps.auth_type = 'private';
        this.stepOneProps.meeting_type = 'private';
        this.stepOneProps.vc_gated = true;
      }
    },
    onScheduleChange() {
      this.errors.schedule = '';
    },
    validate() {
      let ok = true;
      this.errors.event_name = '';
      this.errors.description = '';
      this.errors.schedule = '';

      const name = (this.stepOneProps.event_name || '').trim();
      if (!name) {
        this.errors.event_name = 'Name is required.';
        ok = false;
      }

      const desc = (this.stepOneProps.description || '').trim();
      if (!desc) {
        this.errors.description = 'Description is required.';
        ok = false;
      }

      if (this.authChoice === 'password') {
        const pw = (this.stepOneProps.moderator_password || '').trim();
        if (!pw) {
          this.errors.schedule = '';
          // Reuse a generic field for the password message.
          this.$vs &&
            this.$vs.notify &&
            this.$vs.notify({
              title: 'Password required',
              text: 'Add a password or choose a different access option.',
              color: 'danger',
            });
          ok = false;
        }
      }

      if (!this.isScheduled && !this.isEdit) {
        this.errors.schedule = '';
        return ok;
      }
      const scheduled = moment.tz(
        `${this.stepOneProps.startD} ${this.stepOneProps.startTime}`,
        'YYYY-MM-DD HH:mm:ss',
        this.stepOneProps.timezone ||
          Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      if (!scheduled.isValid()) {
        this.errors.schedule = 'Pick a valid date and time.';
        ok = false;
      } else if (ENFORCE_MIN_LEAD) {
        const earliest = moment().add(MIN_LEAD_HOURS, 'hours');
        if (scheduled.isBefore(earliest)) {
          this.errors.schedule = `Start time must be at least ${MIN_LEAD_HOURS} hour from now.`;
          ok = false;
        }
      }

      return ok;
    },
    triggerLogoUpload() {
      this.$refs.logoInput && this.$refs.logoInput.click();
    },
    triggerCoverUpload() {
      this.$refs.coverInput && this.$refs.coverInput.click();
    },
    onLogoChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.stepTwoProps.logo = file;
      this.logoPreview = URL.createObjectURL(file);
    },
    onCoverChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.stepTwoProps.cover_image = file;
      this.coverPreview = URL.createObjectURL(file);
    },
    removeCover() {
      this.stepTwoProps.cover_image = '';
      this.coverPreview = '';
      if (this.$refs.coverInput) this.$refs.coverInput.value = '';
    },
    openPlatform(platform) {
      if (platform === 'linkedin') {
        this.streamYoutubeUrlDraft = this.streamLinkedinUrl;
        this.streamYoutubeKeyDraft = this.streamLinkedinKey;
      } else {
        this.streamYoutubeUrlDraft = this.streamYoutubeUrl;
        this.streamYoutubeKeyDraft = this.streamYoutubeKey;
      }
      this.showStreamKey = false;
      this.streamErrors = { url: '', key: '' };
      this.streamStage = platform;
    },
    cancelStage() {
      this.streamStage = 'main';
      this.streamErrors = { url: '', key: '' };
    },
    saveStage() {
      const url = (this.streamYoutubeUrlDraft || '').trim();
      const key = (this.streamYoutubeKeyDraft || '').trim();
      this.streamErrors = validateRtmpDestination(url, key, this.streamStage);
      if (this.streamErrors.url || this.streamErrors.key) return;
      if (this.streamStage === 'linkedin') {
        this.streamLinkedinUrl = url;
        this.streamLinkedinKey = key;
        this.streamLinkedinConnected = true;
      } else {
        this.streamYoutubeUrl = url;
        this.streamYoutubeKey = key;
        this.streamYoutubeConnected = true;
      }
      this.streamStage = 'main';
    },
    removeStage() {
      if (this.streamStage === 'linkedin') {
        this.streamLinkedinUrl = '';
        this.streamLinkedinKey = '';
        this.streamLinkedinConnected = false;
      } else {
        this.streamYoutubeUrl = '';
        this.streamYoutubeKey = '';
        this.streamYoutubeConnected = false;
      }
      this.streamYoutubeUrlDraft = '';
      this.streamYoutubeKeyDraft = '';
      this.streamStage = 'main';
    },
    composeStreamPayload() {
      // Mirror StreamPlatformForm.confirm() so the backend (which
      // ast.literal_evals vw_stream_url) reads the same shape.
      if (!this.stepThreeProps) return;
      const urls = [];
      if (
        this.streamYoutubeConnected &&
        this.streamYoutubeUrl &&
        this.streamYoutubeKey
      ) {
        urls.push(`${this.streamYoutubeUrl}/${this.streamYoutubeKey}`);
      }
      if (
        this.streamLinkedinConnected &&
        this.streamLinkedinUrl &&
        this.streamLinkedinKey
      ) {
        urls.push(`${this.streamLinkedinUrl}/${this.streamLinkedinKey}`);
      }
      const streamUrls = [
        { vw_stream: this.vwStream ? 'True' : 'False' },
        { urls },
      ];
      const isStreaming = this.vwStream || urls.length > 0;
      this.stepThreeProps.is_streaming = isStreaming;
      this.stepThreeProps.vw_stream = this.vwStream ? 'True' : 'False';
      this.stepThreeProps.vw_stream_url = JSON.stringify(streamUrls);
    },
    async submit() {
      if (!this.validate()) return;
      this.submitting = true;
      try {
        if (this.isEdit) {
          if (this.handleEditCast) await this.handleEditCast();
          this.closeModal && this.closeModal();
        } else {
          this.composeStreamPayload();
          const ok = this.createCast ? await this.createCast() : false;
          if (ok) {
            this.setActiveModal && this.setActiveModal('castInviteModal');
          }
        }
      } catch (e) {
        // create/edit handlers surface their own notifications.
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.ccf {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 8px 4px 4px;
  color: #fff;
  font-family: 'JetBrains Mono', ui-monospace, monospace;
  width: 640px;
  max-width: calc(100vw - 32px);
}
.ccf-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ccf-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}
.ccf-req {
  color: #d7df23;
}
.ccf-input {
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 12px;
  color: #fff;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s ease;
}
.ccf-input:focus {
  border-color: rgba(215, 223, 35, 0.55);
}
.ccf-textarea {
  resize: vertical;
  min-height: 56px;
}
.ccf-row {
  display: flex;
  gap: 12px;
}
.ccf-half {
  flex: 1 1 0;
  min-width: 0;
}
.ccf-hint {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  margin: -4px 0 0;
}
.ccf-err {
  font-size: 12px;
  color: #f87171;
  margin: 0;
}
.ccf-sub-field {
  margin: 8px 0 0;
}

.ccf-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ccf-pill {
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.02);
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.ccf-pill:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.25);
}
.ccf-pill.active {
  background: rgba(215, 223, 35, 0.12);
  border-color: rgba(215, 223, 35, 0.55);
  color: #d7df23;
}

.ccf-section {
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
}
.ccf-section-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: transparent;
  border: none;
  padding: 12px 14px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}
.ccf-section-chev {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
  transition: transform 0.15s ease;
  display: inline-block;
}
.ccf-section-chev.open {
  transform: rotate(90deg);
}
.ccf-section-meta {
  margin-left: auto;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.35);
}
.ccf-section-body {
  padding: 0 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.ccf-color {
  width: 48px;
  height: 38px;
  padding: 2px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
}
.ccf-color-row {
  display: flex;
  gap: 8px;
  align-items: stretch;
}
.ccf-color-text {
  flex: 1;
  text-transform: uppercase;
  font-family: inherit;
}

.ccf-branding-row {
  align-items: flex-start;
}
.ccf-grow {
  flex: 1;
  min-width: 0;
}

.ccf-upload-tile {
  position: relative;
  border: 1px dashed rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.ccf-upload-tile:hover {
  border-color: rgba(215, 223, 35, 0.55);
  background: rgba(215, 223, 35, 0.05);
}
.ccf-upload-tile.logo {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
}
.ccf-upload-tile.cover {
  width: 100%;
  height: 90px;
}
.ccf-upload-tile.filled {
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.1);
}
.ccf-upload-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.ccf-upload-img.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ccf-upload-hint {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  text-align: center;
  padding: 6px;
}
.ccf-upload-meta {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  margin: 4px 0 0;
}
.ccf-upload-remove {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ccf-note {
  font-size: 12.5px;
  color: #b4b4b4;
  margin: 0 0 10px;
}
.ccf-note.warn {
  color: #f0c45a;
}
.ccf-note.bad {
  color: #ef4444;
}
.ccf-note a {
  color: #d7df23;
  margin-left: 6px;
}
.ccf-toggles {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ccf-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  user-select: none;
}
.ccf-toggle input {
  width: 16px;
  height: 16px;
  accent-color: #d7df23;
}

.ccf-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 6px;
}
.ccf-btn {
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}
.ccf-btn.primary {
  background: #d7df23;
  color: #0b0c14;
}
.ccf-btn.primary:hover:not(:disabled) {
  background: #e7ef33;
}
.ccf-btn.primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.ccf-btn.ghost {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.75);
}
.ccf-btn.ghost:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.25);
}

@media (max-width: 540px) {
  .ccf {
    width: 100%;
  }
  .ccf-row {
    flex-direction: column;
  }
  .ccf-half {
    flex: 1 1 100%;
  }
  .ccf-actions {
    flex-direction: column-reverse;
  }
  .ccf-actions .ccf-btn {
    width: 100%;
  }
}

/* =========================================================
   Live streaming section
   ========================================================= */
.ccf-stream-count {
  color: #d7df23;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.06em;
}

.ccf-stream-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.ccf-stream-card {
  position: relative;
  display: flex;
  text-align: left;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease,
    transform 0.15s ease;
}
.ccf-stream-card:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.18);
  transform: translateY(-1px);
}
.ccf-stream-card.on {
  background: rgba(108, 220, 99, 0.06);
  border-color: rgba(108, 220, 99, 0.35);
}
.ccf-stream-card.on:hover {
  background: rgba(108, 220, 99, 0.09);
  border-color: rgba(108, 220, 99, 0.55);
}
.ccf-stream-card-side {
  width: 3px;
  flex-shrink: 0;
}
.ccf-stream-card-side.decast {
  background: #d7df23;
}
.ccf-stream-card-side.li {
  background: #0a66c2;
}
.ccf-stream-card-side.yt {
  background: #ff0033;
}
.ccf-stream-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  min-width: 0;
}
.ccf-stream-card-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ccf-stream-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ccf-stream-card-icon.li {
  color: #0a66c2;
}
.ccf-stream-card-icon.yt {
  color: #ff0033;
}
.ccf-stream-card-name {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.005em;
  flex: 1;
}
.ccf-stream-card-chev {
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  line-height: 1;
}
.ccf-stream-card-state {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.4);
}
.ccf-stream-card.on .ccf-stream-card-state {
  color: #6cdc63;
}
.ccf-stream-pulse {
  width: 6px;
  height: 6px;
  background: #d7df23;
  border-radius: 50%;
  animation: ccf-stream-pulse 1.6s ease-out infinite;
}
.ccf-stream-pulse.green {
  background: #6cdc63;
}
@keyframes ccf-stream-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(215, 223, 35, 0.55);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(215, 223, 35, 0);
  }
}

/* Inline toggle inside the Decast card */
.ccf-stream-toggle {
  position: relative;
  width: 32px;
  height: 18px;
  background: rgba(255, 255, 255, 0.12);
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.ccf-stream-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #fff;
  transition: transform 0.15s ease, background 0.15s ease;
}
.ccf-stream-toggle.on {
  background: #d7df23;
}
.ccf-stream-toggle.on .ccf-stream-toggle-thumb {
  transform: translateX(14px);
  background: #0b0c14;
}

/* =========================================================
   YouTube stage (in-form view swap)
   ========================================================= */
.ccf-stage-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  align-self: flex-start;
  margin-bottom: 4px;
}
.ccf-stage-back:hover {
  color: #fff;
}
.ccf-stage-head {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ccf-stage-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.04);
}
.ccf-stage-icon.li {
  color: #0a66c2;
  background: rgba(10, 102, 194, 0.12);
}
.ccf-stage-icon.yt {
  color: #ff0033;
}
.ccf-stage-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}
.ccf-stage-title {
  font-size: 20px;
  font-weight: 600;
  margin: 2px 0 0;
  letter-spacing: -0.005em;
}
.ccf-stage-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  margin: 0 0 6px;
  line-height: 1.55;
}
.ccf-stage-key-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.ccf-stage-key-toggle {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.ccf-stage-key-toggle:hover {
  color: #fff;
}

@media (max-width: 540px) {
  .ccf-stream-grid {
    grid-template-columns: 1fr;
  }
}
.ccf-sched-row .ccf-stream-toggle {
  margin-left: auto;
}
.ccf-toggle-disabled {
  opacity: 0.45;
  pointer-events: none;
}
</style>
